import React, { useState, useEffect, useRef} from "react";
import axios from 'axios';
import {
  useNavigate,
  NavLink,
  useSearchParams
} from "react-router-dom";
import gsap from "gsap";
import Loader from "../static/svg/loader.svg";
import Config from "../Config.json"
import Cookies from 'js-cookie';
import Modal from './module.modal';
import Icons from "./module.icons";
import classNames from "classnames";
// Icons
import {ReactComponent as Add} from "../static/icons/library_add.svg" 
import {ReactComponent as ArrowBack} from "../static/icons/arrow_back.svg";
import {ReactComponent as TipsUpdates} from "../static/icons/tips_and_updates.svg";
import {ReactComponent as Library} from "../static/icons/photo_library.svg";
import {ReactComponent as Download} from "../static/icons/download.svg";
import {ReactComponent as Lock} from "../static/svg/padlock.svg";
import {ReactComponent as Info} from "../static/icons/info.svg" 

function Narratives(props) {
  
    const [search, setSearch] = useSearchParams();
    const navigate = useNavigate();
    const formInput = useRef();
    
    const [narratives, setNarratives] = useState([]);
    const [groupedNarratives, setGroupedNarratives] = useState({});
    const [ungroupedNarratives, setUngroupedNarratives] = useState([]);

    const [learn, setLearn] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    const [fetchPath, setFetchPage] = useState();
    const [nextPage, setNextPage] = useState();
    const [prevPage, setPrevPage] = useState();
    const [objCount, setObjCount] = useState(1);
    const [showContextMenu, setShowContextMenu] = useState();
    const [status, setStatus] = useState(null);
    const [showNarrativeForm, setShowNarrativeForm] = useState(false);
    const [formError, setFormError] = useState();
    const [showCategoryForm, setShowCategoryForm] = useState(false);
    const [activeCategory, setActiveCategory] = useState();
    const [showFolderDelete, setShowFolderDelete] = useState(false);

    function fetchNarratives(path) {
      // console.log('fetch')
      let statusPath;
 
      if (status) {
        statusPath = path + '&status=' + status + '&page=1';
      } else {
        statusPath = path + '&status=live,draft,new';
      }
      let cookie;

      console.log('props', props)
      try {
          axios({
              method: 'get',
              url: statusPath,
              headers: {
                Authorization: 'Token ' + Cookies.get('_expo_tokenid'),
              },
          })
          .then(response => {
              const assetJSON = response.data;
              let results;
              if (status) {
                if (status === 'draft') {
                  results = assetJSON.results.filter(a => a.status === status || a.status === 'new');
                  setNarratives(results);
                } else {
                  results = assetJSON.results.filter(a => a.status === status);
                  setNarratives(results);
                }
                
              } else {
                results = assetJSON.results.filter(a => a.status !== 'deleted');
                setNarratives(results);
              }

              const grouped = {};
              const ungrouped = [];
              
              results.forEach((narrative) => {
                if (narrative.group) {
                  if (!grouped[narrative.group.name]) {
                    grouped[narrative.group.name] = { 
                      id: narrative.group.id,
                      name: narrative.group.name,
                      order: narrative.group.ordering,
                      narratives: [] 
                    };
                  }
                  grouped[narrative.group.name].narratives.push(narrative);
                } else {
                  ungrouped.push(narrative);
                }
              });
      
              // Sort groups by ordering_number
              const sortedGroups = Object.entries(grouped)
                .sort((a, b) => a[1].order - b[1].order)
                .reduce((acc, [key, value]) => {
                  acc[key] = {'narratives': value.narratives, 'id': value.id, 'order': value.order, 'name': value.name};
                  return acc;
                }, {});
              
                
              setGroupedNarratives(sortedGroups);
              setUngroupedNarratives(ungrouped);

              console.log(status, results, grouped, ungrouped)

              setShowLoader(false);
              // console.log('narratives', assetJSON)
              setNextPage(assetJSON.next);
              setPrevPage(assetJSON.previous);
              setObjCount(assetJSON.count)
          });
      } catch (error) {
          console.error(error);
      }
    };



    function fetchLearn() {
 
      try {
          axios({
              method: "get",
              url: Config.baseURL + "/api/cms/learn/",
              headers: {
                'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
              },
          }).then((response) => {
              const assetJSON = response.data;
              setLearn(assetJSON);
              setShowLoader(false);
              
          });
      } catch (error) {
          console.error(error);
      }
  }
  
    
  useEffect(() => {        
    


      props.setTools('search');


      let statusParam = search.get('s');
      if (statusParam) {
        setStatus(statusParam);
      }
      

  }, []);

  useEffect(() => {
    if (props) {
      console.log('props.user', props.user)
      if (props.user && props.user.org && props.user.org.validations) {
        console.log('props.user.org', props.user.org.validations)
          // fetchNarratives()
         setFetchPage(Config.baseURL + '/api/cms/narratives/?page=1');
            fetchLearn();
      }
    
    }
  }, [props])


  useEffect(() => {        
    // fetchNarratives()
    if (fetchPath) {
      setShowLoader(true);
      fetchNarratives(fetchPath)
    }
}, [fetchPath, status]);

useEffect(() => {
  if (status) {
    setSearch({'s': status})
  } else {
    setSearch()
  }
  
}, [status])

  useEffect(() => {
    // console.log('narratives', narratives);
  }, [narratives]);


  function onNewNarrativeForm(){
    let narrativeCount = narratives.length;
    if (narrativeCount < props.user.org.validations.maxPresentations) {

     setShowNarrativeForm(true)
    } else {
      let newError = {
        "heading": "Note",
        "text": "You current have <strong>" + narrativeCount + "</strong> spaces, the maximum number of spaces permitted for your organization."
      };
      setFormError(newError);
    }
    


  }

  function handleAddNarrative() {
    setShowNarrativeForm(false)
    setShowLoader(true)

    let narrativeCount = narratives.length;
    console.log('handleAddNarrative', narrativeCount, props.user.org.validations.maxPresentations)
    if (narrativeCount < props.user.org.validations.maxPresentations) {

      var dataJSON = {
        "title": formInput.current,
        "username": props.user.username,
        "org_id": props.user.org.id
      }
      console.log('data', dataJSON)
      if (formInput.current) {
        axios({
          method: 'post',
          url: Config.baseURL + '/api/cms/narrative-add/',
          data: dataJSON,
          headers: {
            Authorization: 'Token ' + Cookies.get('_expo_tokenid')
          },
      })
      .then(response => {
          // fetchNarratives();
          // setFetchPage(Config.baseURL + '/api/cms/narratives/?page=1');
          console.log('response', response.data)
          response && navigate("/narratives/" + response.data )
          formInput.current = null;

      })
      .catch(error => {
          console.log('error', error.response);
      });

      }
    } else {
      let newError = {
        "heading": "Note",
        "text": "You current have <strong>" + narrativeCount + "</strong> spaces, the maximum number of spaces permitted for your organization."
      };
      setFormError(newError);
    }
    


  }

  function onNarrativeContext(e, objId) {
    // console.log('props', props)
    e.preventDefault();
    setTimeout(() => {
      setShowContextMenu(objId);
      // console.log('e', e.pageY, e.target, e)
      gsap.to(".contextMenu", {zIndex: 3, x: e.pageX, y: e.pageY - 20, duration: 0});
      gsap.to(".contextMenu", {opacity: 1, duration: 0.3}, "-=0.3");
      let listener = window.addEventListener('click', function(){
        setShowContextMenu(false);
        gsap.to(".contextMenu", {opacity: 0, zIndex: -1, duration: 0});
      })
      window.removeEventListener('click', listener); 
    }, 100);
    
  }

  function handleNarrativeSave(objId, field, value) {
    setShowLoader(true)
    const api_url = Config.baseURL + '/api/cms/narrative-settings/' + objId + "/";
    var dataJSON = {};
    if (field !== 'title') {
      dataJSON['title'] = narratives.find(a => a.id === objId).title
    }
    dataJSON[field] = value;

    console.log('handleNarrativeSave', dataJSON)
    
    axios({
        method: 'POST',
        url: api_url,
        data: dataJSON,
        headers: {
          Authorization: 'Token ' + Cookies.get('_expo_tokenid')
        },
    })
    .then(response => {
      fetchNarratives(Config.baseURL + '/api/cms/narratives/?page=1');
      setFetchPage(Config.baseURL + '/api/cms/narratives/?page=1');
      console.log('response, del', response.data)
    })
    .catch(error => {
        console.log('error', error.response);
    });
  }

  function trash(objId) {
    setFormError(null);
    setShowLoader(true);
    axios({
        method: 'post',
        url: Config.baseURL + '/api/cms/narrative-delete/',
        data: {"id": objId, "trash": true},
        headers: {
          Authorization: 'Token ' + Cookies.get('_expo_tokenid')
        },
    })
    .then(response => {
        fetchNarratives(Config.baseURL + '/api/cms/narratives/?page=1');
        setFetchPage(Config.baseURL + '/api/cms/narratives/?page=1');
        console.log('response, del', response.data)
        // setFormError(null)
        showLoader(false);
    })
    .catch(error => {
      console.log('error', error.response);
    });
  }


  function handleNarrativeContextBtn(objId, action) {
    
    switch (action) {
      case "lock":
        setShowLoader(true);
        axios({
            method: 'post',
            url: Config.baseURL + '/api/cms/narrative-lock/',
            data: {"id": objId, "username": props.user.username, "lock": true},
            headers: {
              Authorization: 'Token ' + Cookies.get('_expo_tokenid')
            },
        })
        .then(response => {
            fetchNarratives(Config.baseURL + '/api/cms/narratives/?page=1');
            setFetchPage(Config.baseURL + '/api/cms/narratives/?page=1');
            console.log('response, dup', response.data)
        })
        .catch(error => {
            console.log('error', error.response);
        });
        break;
      case "unlock":
          setShowLoader(true);
          axios({
              method: 'post',
              url: Config.baseURL + '/api/cms/narrative-lock/',
              data: {"id": objId, "username": props.user.username, "lock": false},
              headers: {
                Authorization: 'Token ' + Cookies.get('_expo_tokenid')
              },
          })
          .then(response => {
              fetchNarratives(Config.baseURL + '/api/cms/narratives/?page=1');
              setFetchPage(Config.baseURL + '/api/cms/narratives/?page=1');
              console.log('response, dup', response.data)
          })
          .catch(error => {
              console.log('error', error.response);
          });
          break;
      case "dup":

      let narrativeCount = narratives.length;
      if (narrativeCount < props.user.org.validations.maxPresentations) {

        setShowLoader(true);
        axios({
            method: 'post',
            url: Config.baseURL + '/api/cms/narrative-duplicate/',
            data: {"id": objId, "username": props.user.username},
            headers: {
              Authorization: 'Token ' + Cookies.get('_expo_tokenid')
            },
        })
        .then(response => {
           
            console.log('response, dup', response.data)

            let logId = response.data['log_id']

            setInterval(() => {
              try {
                axios({
                    method: "get",
                    url: Config.baseURL + "/api/cms/narrative-duplicate-status/" + logId,
                    headers: {
                      Authorization: 'Token ' + Cookies.get('_expo_tokenid')
                    },
                }).then((response) => {
                
                    if (response.data['complete']) {
                      fetchNarratives(Config.baseURL + '/api/cms/narratives/?page=1');
                      setFetchPage(Config.baseURL + '/api/cms/narratives/?page=1');
                      console.log('duplicate ready')
                    } else {
                      console.log('still duplicating', logId)
                    }
                    
                    
                   
                   
                    
                });
            } catch (error) {
                console.error(error);
            }
            }, 10000);


        })
        .catch(error => {
            console.log('error', error.response);
        });

      } else {
        let newError = {
          "heading": "Note",
          "text": "You current have <strong>" + narrativeCount + "</strong> spaces, the maximum number of spaces permitted for your organization."
        };
        setFormError(newError);

      }
        break;
      case "del": 
        setShowLoader(true);
        axios({
            method: 'post',
            url: Config.baseURL + '/api/cms/narrative-delete/',
            data: {"id": objId},
            headers: {
              Authorization: 'Token ' + Cookies.get('_expo_tokenid')
            },
        })
        .then(response => {
            fetchNarratives(Config.baseURL + '/api/cms/narratives/?page=1');
            setFetchPage(Config.baseURL + '/api/cms/narratives/?page=1');
            console.log('response, del', response.data)
        })
        .catch(error => {
            console.log('error', error.response);
        });
        break;
      case "trash":
        let newError = {
          "heading": "Caution",
          "text": "Are you sure you want to delete this narrative?<br />This action cannot be undone.",
          "btn2Text": "Continue",
          "onBtn2Click": trash,
          "onBtn2": objId
        };
        setFormError(newError);
        console.log('handleNarrativeContextBtn', action, objId, newError)
        break;

      case "act":
        setShowLoader(true);
      handleNarrativeSave(objId, 'status', 'draft')
        break;
    
      default:
        break;
    }

    setShowContextMenu(false);
    gsap.to(".contextMenu", {opacity: 0, zIndex: -1, duration: 0});


  }

  async function onDownload(){
    let result = await navigator.userAgentData.getHighEntropyValues(['architecture']);
    let build;
    let baseUrl = "https://present.udxd.co/download/";
    if (result.platform === "macOS") {
      if (result.architecture === "arm") {
        build = 'PresentationDesktop-arm64-mac.dmg'
      } else {
        build = 'PresentationDesktop-mac.dmg'
      }
    } else {
      build = 'Presentation-Desktop-Setup-beta.exe'
    }
    console.log('result', result, build);
    return window.open(baseUrl + build, '_blank');
    
  }

  function onUpdateFolderBtn(obj){
    // document.getElementById("updateFolderModal_" + objId).classList.toggle('on');
    if (activeCategory && activeCategory.id === obj.id) {
      setActiveCategory(null)
    } else {
      setActiveCategory(obj)
    }
    
  }

  function onUpdateFolder(action, objId){
    console.log('onUpdateFolder', action)
    // onUpdateFolderBtn(objId)
    if (action === 'rename'){

      setShowCategoryForm(true)
    } 
    if (action === 'delete') {
      setShowFolderDelete(true);
    }
  }

  function onDeleteFolder(){
    const api_url = Config.baseURL + "/api/cms/narrative-group/" + activeCategory.id + "/";
    var dataJSON = {
      'delete': true
    };
    axios({
      method: "POST",
      url: api_url,
      data: dataJSON,
      headers: {
        Authorization: "Token " + Cookies.get("_udxdid"),
      },
    })
      .then((response) => {
        fetchNarratives(fetchPath);
        setShowCategoryForm(false);
        setShowFolderDelete(false);
      })
      .catch((error) => {
        console.log("error", error.response);
      });
  }

  useEffect(() => {
    if (!showCategoryForm) {
      setActiveCategory(null)
    }
  }, [showCategoryForm])

  function handleUpdateCategory(name, ordering) {
    console.log('handleUpdateCategory', name, ordering, activeCategory)
    setShowLoader(true);
    const api_url = Config.baseURL + "/api/cms/narrative-group/" + activeCategory.id + "/";
    var dataJSON = {
      'name': name,
      'ordering': ordering
    };
    axios({
      method: "POST",
      url: api_url,
      data: dataJSON,
      headers: {
        Authorization: "Token " + Cookies.get("_udxdid"),
      },
    })
      .then((response) => {
       
        fetchNarratives(fetchPath);
        setShowCategoryForm(false);
        console.log("response, update", response.data);
      })
      .catch((error) => {
        console.log("error", error.response);
      });
  }

  let activeClassName = "on";

  return (

      <section className="main" id="narrativesPage">
       {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}

       {(formError)&&<Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Cancel"} onBtn2Click={formError.onBtn2Click} onBtn2={formError.onBtn2} btn2Text={formError.btn2Text} />}

       {showNarrativeForm && <Modal heading={"New Space"} formInput={<div className="settingsRow"><input type="text" autoComplete="off" id="narrativeTitle" required onChange={(e) => {formInput.current = e.target.value}} placeholder="Add a Title" /></div>} onBtn1Click={setShowNarrativeForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={handleAddNarrative} onBtn2={null} btn2Text={"Create"} />}

       {showFolderDelete && (
        <div id="errorPopup">
          <div className="modal">
            <span>
              <h3>Delete <span className={'underline'} dangerouslySetInnerHTML={{__html: activeCategory.name}} /></h3>
             
              <p>Are you sure?</p>
            </span>{" "}
            <div className="fullRow errorRow">
              <span onClick={() => setShowFolderDelete(false)}>Cancel</span>{" "}
              <span onClick={() => onDeleteFolder()}>Delete</span>
            </div>
          </div>
        </div>
      )}

       {showCategoryForm && (
        <div className="modalContainer categoryModal">
          <div className="modal">
            <span className="modalBox">
              <h3>{activeCategory ? (<span>Rename <span className={'underline'} dangerouslySetInnerHTML={{__html: activeCategory.name}}></span></span>) : "New Category"}</h3>
             
              <div className="settingsRow">
              <span className="canvasLabel">Name</span>
                <input
                  type="text"
                  autoComplete="off"
                  id="newCategoryName"
                  autoFocus
                  placeholder="Add Category Name"
                  defaultValue={activeCategory && activeCategory.name}
                />
              </div>
              
              <div className="settingsRow">
              <span className="canvasLabel">Ordering</span>
                <input
                  type="number"
                  autoComplete="off"
                  id="newCategoryOrdering"
                  placeholder="Add Ordering Number"
                  defaultValue={activeCategory && activeCategory.order}
                />
              </div>
            </span>{" "}
            <div className="fullRow errorRow">
              <span
                onClick={() => {
                  setShowCategoryForm(false);
                }}
              >
                Cancel
              </span>{" "}
              <span
                onClick={() =>
                 { 
                  if (activeCategory) {
                    handleUpdateCategory(
                      document.getElementById("newCategoryName").value,
                      document.getElementById("newCategoryOrdering").value,
                    )
                  } 
                  // else {
                  //   handleAddCategory(
                  //     document.getElementById("newCategoryName").value
                  //   )
                  // }
                }
                }
              >
                Continue
              </span>
            </div>
          </div>
        </div>
      )}

       {showContextMenu !== false && (status !== 'deleted') && <div className="contextMenu">
          {(narratives.find(a => a.id === showContextMenu) && narratives.find(a => a.id === showContextMenu).locked) ? <span className="contextBtn" onClick={() => handleNarrativeContextBtn(showContextMenu, "unlock")}>Unlock</span> : <span className="contextBtn" onClick={() => handleNarrativeContextBtn(showContextMenu, "lock")}>Lock</span>}
          <span className="break"></span>
          <span className="contextBtn" onClick={() => handleNarrativeContextBtn(showContextMenu, "dup")}>Duplicate</span>
          <span className="break"></span>
          <span className="contextBtn" onClick={() => handleNarrativeContextBtn(showContextMenu, "del")}>Delete</span>
        </div>}

        {showContextMenu !== false && (status === 'deleted') && <div className="contextMenu">
          <span className="contextBtn" onClick={() => handleNarrativeContextBtn(showContextMenu, "act")}>Return to Draft</span>
          <span className="break"></span>
          <span className="contextBtn" style={{display: "none"}} onClick={() => handleNarrativeContextBtn(showContextMenu, "trash")}>Delete Permanently</span>
        </div>}


        
        <div className="col appGrid">
          <nav className="leftNav homeLeftNav">

            <div className="leftNavGroup">
                <div className="groupLabel">CONTENT</div>
                <div className="homeBtn ui">
                
                <a href={"/library"} className="iconField"><Library className="icon" />Asset Library</a>
  
                </div>

                
                
            </div>

             {narratives && narratives.length > 0 && <div className="leftNavGroup">
                <div className="groupLabel">TEMPLATES</div>
                <div className="homeBtn ui">
                
                <a href={"/narratives/" + narratives[0].template_id + '/pages?back=home'} className="iconField"><Icons.AddTemplate className="icon ui" title="Template Editor"  />Template Editor</a>
  
                </div>

                
                
            </div>}
        
       
              <div className="leftNavGroup">
                <div className="groupLabel">HELP</div>
                <div className="homeBtn ui">
                
                <a href={"/learn"} className="iconField"><TipsUpdates className="icon" />Learn</a>
  
                </div>

                <div className="homeBtn ui" onClick={() => props.setShowInfo(!props.showInfo)}>                   
                  <span className="iconField"><Info className="icon" /> Version</span>
                </div>
                
              </div>
              <div className="leftNavGroup" style={{display: "none"}}>
              <div className="groupLabel">DOWNLOADS</div>
                <div className="homeBtn ui">
                  <div className="iconField" onClick={() => onDownload()}>Desktop <Download className="icon" /></div>
                </div>
               
            </div>
          </nav>
          <div className="core">
              <div className="subNav homeSubNav">
                <ul className="flat">
                <li>
                  <div onClick={() => setStatus(null)} className={`homeBtn ui${status===null?" on":""}`}>Recent</div>
                </li>
                <li>
                  <div onClick={() => setStatus("live")} className={`homeBtn ui${status==="live"?" on":""}`}>Live</div>
                </li>
                <li>
                  <div onClick={() => setStatus("draft")}  className={`homeBtn ui${status==="draft"?" on":""}`}>Drafts</div>
                </li>
                <li>
                  <div onClick={() => setStatus("deleted")} className={`homeBtn ui${status==="deleted"?" on":""}`}>Deleted</div>
                </li>

                </ul>
          
              </div>
              <div className="flex flexColumn">
              <span className='grid'>
              {!prevPage && <div className="gridItem" onClick={() => onNewNarrativeForm()}>
                <div className={"gridThumb addNew ui"}>
                    <span>
                      <Add className="icon" />
                      New
                    </span>
                  
                </div>
    
              </div>}
              </span>

              {Object.entries(groupedNarratives).map(([groupName, groupObj]) => (
                <div key={groupName} className="flex flexColumn row groupRow">
                  <h2>
             
                    <strong>{groupName.toUpperCase()}</strong>
                    <span>
                      <Icons.Ellipses className="icon ui" onClick={() => onUpdateFolderBtn(groupObj)} />
                      <span 
                      className={classNames('smModal', 'groupNameModal', activeCategory && activeCategory.id === groupObj.id && 'on')}
                      >
                       
                          <span className={'smModalChoice ui'} onClick={() => onUpdateFolder('rename', groupObj.id)}><Icons.Pencil className="icon ui" /> Edit</span>
                          <span className={'smModalChoice ui'} onClick={() => onUpdateFolder('delete', groupObj.id)}><Icons.Delete className="icon ui" />Delete</span>
                      </span>
                    </span>
                  </h2>
                  <span className='grid'>
             
                    {groupObj['narratives'].map((narrative) => (
                      <NavLink 
                      key={narrative.id}
                      to={((narrative.status !== 'deleted' && !narrative.locked) ?('/narratives/' + narrative.id):"#")}
                      onContextMenu={(e) => onNarrativeContext(e, narrative.id)}
                      // onClick={() => handlePageChange(route.path)}
                      className={({ isActive }) =>
                          ("gridItem" + (narrative.locked ? " locked":""))
                        }
                    >
                        <div className="gridThumb">
            
                          {narrative && narrative.screenshot && <img src={Config.mediaURL + narrative.screenshot} alt="narrative thumb" />}
                        </div>
                        
                        <span className="gridHeading">{narrative.subheading ? narrative.subheading: narrative.title} {narrative.status === 'new' ? <span className="newIcon"><svg className="iconSm" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" /></svg></span>:""} {narrative.locked && <span className="lock"><Lock className="icon" /></span>}</span>
                        
                    </NavLink>
            
                    ))}
                    </span>
                </div>
              ))}

                {ungroupedNarratives.length > 0 && (
                  <div className="flex flexColumn">
                  <span className='grid'>
              
                      {ungroupedNarratives.map((narrative) => (
                        <NavLink 
                        key={narrative.id}
                        to={((narrative.status !== 'deleted' && !narrative.locked) ?('/narratives/' + narrative.id):"#")}
                        onContextMenu={(e) => onNarrativeContext(e, narrative.id)}
                        // onClick={() => handlePageChange(route.path)}
                        className={({ isActive }) =>
                            ("gridItem" + (narrative.locked ? " locked":""))
                          }
                      >
                          <div className="gridThumb">
              
                            {narrative && narrative.screenshot && <img src={Config.mediaURL + narrative.screenshot} alt="narrative thumb" />}
                          </div>
                          
                          <span className="gridHeading">{narrative.subheading ? narrative.subheading: narrative.title} {narrative.status === 'new' ? <span className="newIcon"><svg className="iconSm" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" /></svg></span>:""} {narrative.locked && <span className="lock"><Lock className="icon" /></span>}</span>
                          
                      </NavLink>
                      ))}
                      </span>
                  </div>
                )}
              
              </div>



          
              <div className="pageNav">
                    <div className={"prevPage iconField" + (!prevPage ? " disabled" : " ui")} onClick={() => prevPage && setFetchPage(prevPage)}><ArrowBack className="icon" />Previous</div>
                    <div className={"nextPage iconField" + (!nextPage ? " disabled" : " ui")} onClick={() => nextPage && setFetchPage(nextPage)}>Next<ArrowBack className="icon flip" /></div>
                    
              </div>
          </div>      
        </div>
      </section>

   
  )

}
export default Narratives;


// {(narratives.map((narrative, i) =>
//   <NavLink 
//     key={"narrative_" + narrative.id}
//     to={((narrative.status !== 'deleted' && !narrative.locked) ?('/narratives/' + narrative.id):"#")}
//     onContextMenu={(e) => onNarrativeContext(e, narrative.id)}
//     // onClick={() => handlePageChange(route.path)}
//     className={({ isActive }) =>
//         ("gridItem" + (narrative.locked ? " locked":""))
//       }
//   >
//       <div className="gridThumb">

//         {narrative && narrative.screenshot && <img src={Config.mediaURL + narrative.screenshot} alt="narrative thumb" />}
//       </div>
      
//       <span className="gridHeading">{narrative.subheading ? narrative.subheading: narrative.title} {narrative.status === 'new' ? <span className="newIcon"><svg className="iconSm" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" /></svg></span>:""} {narrative.locked && <span className="lock"><Lock className="icon" /></span>}</span>
      
//   </NavLink>

// ))}
